'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect, useRef, useState } from 'react';

import cx from 'classnames';
import { useFavorites } from 'contexts/FavoritesContext';

import Link from 'components/ui/Link';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import styles from './FavoritesNotifier.module.scss';

const FavoritesNotifier = () => {
    const { favorites, initialized } = useFavorites();
    const [showFavoriteNotifier, setShowFavoriteNotifier] = useState(false);
    const previousFavoritesCount = useRef(0);
    const hasInitialized = useRef(false);

    // Watch for favorites being added and trigger notification
    useEffect(() => {
        const currentCount = favorites.length;
        const previousCount = previousFavoritesCount.current;

        // Skip notification on initial load - wait for context to initialize
        if (!initialized) {
            return;
        }

        // Set initial count after first initialization
        if (!hasInitialized.current) {
            previousFavoritesCount.current = currentCount;
            hasInitialized.current = true;
            return;
        }

        // Always update the ref first, before any early returns
        previousFavoritesCount.current = currentCount;

        // Only show notification if favorites count increased (item was added)
        if (currentCount > previousCount) {
            setShowFavoriteNotifier(true);

            // Hide notification after 4 seconds
            const timer = setTimeout(() => {
                setShowFavoriteNotifier(false);
            }, 4000);

            return () => clearTimeout(timer);
        }
    }, [favorites.length, initialized]);

    return (
        <div
            className={cx(styles.favoriteNotifier, {
                [styles.favoriteNotifierVisible]: showFavoriteNotifier,
            })}
            data-favorite-notifier
            inert={showFavoriteNotifier ? undefined : true}
        >
            <div className={styles.favoriteNotifierContent}>
                <div className={styles.favoriteNotifierIcon}>
                    <SvgIcon type="heartChecked" />
                </div>
                <Text variant="body">Added to your favorites!</Text>
                <Link href="/favorites">View</Link>
            </div>
        </div>
    );
};

export default FavoritesNotifier;
